<template>
<div class="chapter">
<div class="inner_page">
<a id="pvii"></a>
<blockquote class="sink">
<p class="left "><em>For Lincoln County—</em><br/>
<em>Past, Present and Future</em></p>
</blockquote>
<div class="timebreak "> </div>
<blockquote>
<p class="left "><em>and</em></p>
</blockquote>
<div class="timebreak "> </div>
<blockquote>
<p class="left "><em>In Memoriam</em><br/>
<em>Bill Shearer</em><br/>
<em>1952–1996</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?65d0996a